import { DateUtilService } from '../date-utils';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import * as FileSaver from 'file-saver';
import { PreloaderService } from '../preloader.service';
import { WebapiService } from '../webapi.service';

@Component({
  selector: 'app-client-mis-new',
  templateUrl: './client-mis-new.component.html',
  styleUrls: ['./client-mis-new.component.scss']
})
export class ClientMisNewComponent implements OnInit {
  filterData: any = {
    year: '',
    month: '',
    applicationId: '',
    compDate: '',
    clientId: '',
    status: '',
    color: '',
    checkName: '',
    page:1,
    limit:10,
  };
  checkList: any = [];
  responseData: any;
  clickedData: any = [];
  reportUrl: any;
  processListSelect: any = [];
  s3Url: any = "";

  months: any[] = [
    { value: 1, name: 'January' },
    { value: 2, name: 'February' },
    { value: 3, name: 'March' },
    { value: 4, name: 'April' },
    { value: 5, name: 'May' },
    { value: 6, name: 'June' },
    { value: 7, name: 'July' },
    { value: 8, name: 'August' },
    { value: 9, name: 'September' },
    { value: 10, name: 'October' },
    { value: 11, name: 'November' },
    { value: 12, name: 'December' }
  ];
  years: number[] = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i); // Last 10 years

  statusOrder = ['NEW', 'INPROGRESS', 'QC', 'STOPPED', 'COMPLETED'];
  statusDisplayNames = {
    'NEW': 'New',
    'INPROGRESS': 'Work In Progress',
    'QC': 'QC',
    'STOPPED': 'Stopped',
    'COMPLETED': 'Complete'
  };
  clickTotal: number=0;
  p:any=1;

  constructor(public dateUtil: DateUtilService, private webapiservice: WebapiService, private router: Router, private spinner: PreloaderService) {
    this.reportUrl = this.webapiservice.reportUrl;
    this.s3Url = this.webapiservice.s3Url;
  }
  ngOnInit(): void {
    let clientId = sessionStorage.getItem('loginId');
    this.filterData.clientId = clientId;
    this.filterData.year = new Date().getFullYear(); // Set current year as default
    this.getAllCheck();
    this.onFilterData(this.filterData);
  }

  getAllCheck() {
    this.webapiservice.getAllCheck().subscribe((res: any) => {
      this.checkList = res.setting;
    });
  }

  onTableDataChange(event: any) {
    this.filterData.page = event;
    this.getClientDataAll(this.filterData)
    this.p = event;
 }

  // onFilterData(data: any) {
  //   // this.spinner.show();
  //   this.webapiservice.getClientMisCount(data).subscribe((res: any) => {
  //     if (res.status == 'ok') {
  //       // this.spinner.hide();
  //       this.responseData = res.data?.statusCounts || {};
  //       this.getClientDataAll(data);
  //     }
  //     else {
  //       this.responseData = {};
  //       // this.spinner.hide();
  //     }
  //   });
  // }

  onFilterData(data: any) {
    this.spinner.show();
    this.webapiservice.getClientMisCount(data).subscribe((res: any) => {
      if (res.status === 'ok') {
        this.responseData = res.data?.statusCounts || {};
        this.getClientDataAll(data);
      } else {
        this.responseData = {};
      }
      this.spinner.hide();
    }, error => {
      console.error('Error loading data:', error);
      this.spinner.hide();
    });
  }

  getCheckList(): string[] {
    if (!this.responseData) return [];
    
    const allChecks = new Set<string>();
    Object.values(this.responseData).forEach((status: any) => {
      if (status?.checks) {
        Object.keys(status.checks).forEach(check => allChecks.add(check));
      }
    });
    return Array.from(allChecks);
  }

  // Get the total count for a specific check and status
  getCheckCount(status: string, checkName: string): number {
    if (!this.responseData[status]?.checks?.[checkName]) return 0;
    
    const checkData = this.responseData[status].checks[checkName];
    // Sum all status counts for this check
    return Object.values<number>(checkData as Record<string, number>).reduce(
      (sum: number, count: number) => sum + (typeof count === 'number' ? count : 0), 
      0
    );
  }
  
  // Get count for a specific check and status (e.g., COMPLETED, INPROGRESS, etc.)
  getCheckStatusCount(status: string, checkName: string, checkStatus: string): number {
    return this.responseData[status]?.checks?.[checkName]?.[checkStatus] || 0;
  }
  
  // Get the status with the highest count for a check
  getMainStatusForCheck(status: string, checkName: string): string {
    try {
      const checkData = this.responseData[status]?.checks?.[checkName];
      if (!checkData) return '';
      
      let maxStatus = '';
      let maxCount = 0;
      
      // Find the status with the highest count
      Object.entries<number>(checkData).forEach(([status, count]) => {
        const currentCount = Number(count) || 0;
        if (currentCount > maxCount) {
          maxCount = currentCount;
          maxStatus = status;
        }
      });
      
      return maxStatus;
    } catch (error) {
      console.error('Error in getMainStatusForCheck:', error);
      return '';
    }
  }

  getClientDataAll(data: any) {
    this.webapiservice.getMisClientDataAll(data).subscribe((res: any) => {
      if (res.status == 'ok') {
        this.clickedData = res?.data;
        this.clickTotal = res?.total;
      }
      else {
        this.clickedData = [];
        this.clickTotal = 0;
      }
    });
  }

  getDataByStatus(status: string) {
    const filter = { ...this.filterData };
    filter.status = status;
    filter.color = '';
    filter.checkName = '';
    this.filterData.status = status;
    this.filterData.color = '';
    this.filterData.checkName = '';
    this.onFilterData(filter);
  }

  getDataByColor(status: string, color: string) {
    const filter = { ...this.filterData };
    filter.status = status;
    filter.color = color;
    filter.checkName = '';
    this.filterData.status = status;
    this.filterData.color = color;
    this.filterData.checkName = '';
    this.onFilterData(filter);
  }

  getDataByCheck(status: string, checkName: string) {
    const filter = { ...this.filterData };
    const mainStatus = this.getMainStatusForCheck(status, checkName) || status;
    filter.status = mainStatus;
    filter.checkName = checkName;
    filter.color = '';
    this.filterData.status = mainStatus;
    this.filterData.checkName = checkName;
    this.filterData.color='';
    this.onFilterData(filter);
  }
  
  // New method to handle check status clicks
  onCheckStatusClick(status: string, checkName: string, checkStatus: string) {
    const filter = { ...this.filterData };
    filter.status = checkStatus; // Use the specific check status for filtering
    filter.checkName = checkName;
    filter.color = '';
    this.onFilterData(filter);
  }

     getExcelDownload(data:any){
      data.exportType = 'check';
      this.webapiservice.exportMisReport(data).subscribe((res: any) => {
      const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       FileSaver.saveAs(blob, 'MisReport.xlsx');
      });
     }

}
